.fileLink {
    text-decoration: none;
    cursor: pointer;
}

.fileLink:hover {
    text-decoration: underline;
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: -0.125em;
    flex-shrink: 0;
}

.downloadIcon {
    composes: icon;
    display: none;
}

.fileLink:hover .icon {
    display: none;
}

.fileLink:hover .downloadIcon {
    display: inline-block;
}

/* Right column: label left, icon pushed to the column's right edge
   (DibApp2020 FileRef variant="related"). */
.row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.row .icon {
    margin-left: var(--mantine-spacing-md);
}

/* Slider panel: icon trails the label, like in-content file links. */
.inline .icon {
    margin-left: 0.25em;
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
}
